// import React from "react";

// const NotFound = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 flex items-center justify-center p-4">
//       <div className="max-w-md w-full text-center">
//         {/* Animated Rocket Icon */}
//         <div className="relative">
//           <div className="flex justify-center items-center">
//             <div className="relative">
//               <svg
//                 className="w-32 h-32 text-white/10"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" />
//               </svg>
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <svg
//                   className="w-20 h-20 text-pink-400 animate-pulse"
//                   fill="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" />
//                 </svg>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Glowing orb decoration */}
//         <div className="relative mb-8">
//           <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full blur-3xl opacity-20 animate-pulse"></div>
//           <div className="relative z-10">
//             <h2 className="text-4xl font-bold text-white mb-2 animate-fade-in">
//               This page isn't here
//             </h2>
//             <h3 className="text-2xl font-semibold text-purple-300 mb-4 animate-fade-in">
//               Lost in Space
//             </h3>
//             <p className="text-gray-300 text-lg mb-8 leading-relaxed">
//               Looks like it's lost in space. Let's navigate you back to planet
//               Earth.
//             </p>
//           </div>
//         </div>

//         {/* Animated home button */}
//         <button
//           onClick={() => (window.location.href = "/")}
//           className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-transparent"
//         >
//           <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full blur opacity-75 group-hover:opacity-100 transition-opacity duration-300"></div>
//           <div className="relative bg-gradient-to-r from-pink-500 to-purple-600 rounded-full px-8 py-4 group-hover:from-pink-400 group-hover:to-purple-500 transition-all duration-300">
//             <span className="flex items-center">
//               <svg
//                 className="w-5 h-5 mr-2 transition-transform duration-300 group-hover:-translate-x-1"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M10 19l-7-7m0 0l7-7m-7 7h18"
//                 />
//               </svg>
//               Return to Earth
//             </span>
//           </div>
//         </button>

//         {/* Floating particles */}
//         <div className="absolute inset-0 pointer-events-none">
//           <div
//             className="absolute top-1/4 left-1/4 w-2 h-2 bg-pink-400 rounded-full opacity-60 animate-bounce"
//             style={{ animationDelay: "0s" }}
//           ></div>
//           <div
//             className="absolute top-1/3 right-1/4 w-1 h-1 bg-purple-400 rounded-full opacity-60 animate-bounce"
//             style={{ animationDelay: "1s" }}
//           ></div>
//           <div
//             className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-pink-300 rounded-full opacity-60 animate-bounce"
//             style={{ animationDelay: "2s" }}
//           ></div>
//           <div
//             className="absolute bottom-1/3 right-1/3 w-2 h-2 bg-purple-300 rounded-full opacity-60 animate-bounce"
//             style={{ animationDelay: "0.5s" }}
//           ></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NotFound;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const glitchText = (text) => {
    return text.split("").map((char, index) => (
      <span
        key={index}
        className="inline-block animate-pulse"
        style={{
          animationDelay: `${index * 0.1}s`,
          animationDuration: "2s",
        }}
      >
        {char}
      </span>
    ));
  };

  return (
    <div className="min-h-screen bg-black relative overflow-hidden flex items-center justify-center">
      {/* Animated Grid Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 via-blue-500 to-purple-500"></div>
        <div
          className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[length:50px_50px]"
          style={{
            transform: `translate(${mousePosition.x * 0.01}px, ${
              mousePosition.y * 0.01
            }px)`,
          }}
        ></div>
      </div>

      {/* Floating Geometric Shapes */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-20 w-4 h-4 bg-cyan-400 rotate-45 animate-spin opacity-60"></div>
        <div className="absolute top-40 right-32 w-6 h-6 bg-purple-400 rounded-full animate-pulse opacity-50"></div>
        <div className="absolute bottom-32 left-16 w-3 h-3 bg-yellow-400 rotate-45 animate-bounce opacity-70"></div>
        <div className="absolute bottom-20 right-20 w-5 h-5 bg-pink-400 rounded-full animate-ping opacity-60"></div>
        <div className="absolute top-1/2 left-10 w-2 h-8 bg-green-400 animate-pulse opacity-50"></div>
        <div className="absolute top-1/4 right-12 w-8 h-2 bg-blue-400 animate-bounce opacity-50"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 text-center px-4 max-w-2xl">
        {/* Glitch Effect 404 */}
        <div className="relative mb-8">
          <h1 className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 mb-4 select-none">
            {glitchText("404")}
          </h1>
          <div className="absolute inset-0 text-8xl md:text-9xl font-black text-red-500 opacity-20 animate-pulse select-none">
            404
          </div>
        </div>

        {/* Animated Circuit Lines */}
        <div className="relative mb-8">
          <div className="absolute left-1/2 top-0 w-px h-16 bg-gradient-to-b from-cyan-400 to-transparent animate-pulse"></div>
          <div className="absolute left-1/2 top-16 w-4 h-4 border-2 border-cyan-400 rounded-full animate-ping"></div>
          <div className="absolute left-1/2 top-20 w-px h-12 bg-gradient-to-b from-cyan-400 to-transparent animate-pulse"></div>
        </div>

        {/* Error Message */}
        <div className="mb-8 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
              This page isn't here
            </span>
          </h2>
          <h3 className="text-2xl font-semibold text-purple-300 mb-4">
            Lost in Space
          </h3>
          <p className="text-xl text-gray-300 leading-relaxed">
            Looks like it's lost in space. Let's navigate you back to planet
            Earth.
          </p>
        </div>

        <button
          onClick={() => navigate("/")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-black bg-gradient-to-r from-cyan-400 to-purple-400 rounded-lg transform transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-black"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-purple-400 rounded-lg blur opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>
          <div className="relative flex items-center space-x-2">
            <svg
              className={`w-5 h-5 transition-transform duration-300 ${
                isHovered ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
              />
            </svg>
            <span>Return to Earth</span>
          </div>
        </button>

        {/* Status Bar */}
        <div className="mt-12 flex justify-center">
          <div className="bg-gray-900 border border-gray-700 rounded-lg px-6 py-3 font-mono text-sm text-green-400">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <span>STATUS: NOT_FOUND</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
                <span>CODE: 404</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>SYSTEM: ACTIVE</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ambient Light Effect */}
      <div
        className="absolute w-96 h-96 bg-gradient-to-r from-cyan-500 to-purple-500 rounded-full blur-3xl opacity-10 pointer-events-none"
        style={{
          left: mousePosition.x - 192,
          top: mousePosition.y - 192,
          transition: "all 0.1s ease-out",
        }}
      ></div>

      {/* Scanlines Effect */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-400 to-transparent opacity-5 animate-pulse h-1 scanline"></div>
      </div>

      <style jsx>{`
        @keyframes scanline {
          0% {
            transform: translateY(-100vh);
          }
          100% {
            transform: translateY(100vh);
          }
        }
        .scanline {
          animation: scanline 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default NotFound;
